import axios from '@/mod/axiosMod';

export default {
  // https://km.sankuai.com/page/1108025782 接口文档

  /**
   * 查询银行卡和客户信息
   * @param {}
   * @returns {*}
   */
  getBankInfo() {
    return axios.get('/apigw/api/kdb/get-bank-info');
  },

  /**
   * OCR识别银行卡
   * @param url 上传图片得到的url地址
   * @returns {*}
   */
  getBackNumberByUrl(url) {
    return axios.get('/apigw/api/ocr/discern/bank-card', {
      params: {
        url,
      },
    });
  },

  /**
   * OCR识别身份证
   * @param url 上传图片得到的url地址
   * @returns {*}
   */
  getIdCardByUrl(url) {
    return axios.get('/apigw/api/ocr/discern/identity-card', {
      params: {
        url,
      },
    });
  },

  /**
   * 查询省份信息
   * @param {*}
   * @returns {*}
   */
  getProvinceList() {
    return axios.get('/apigw/api/common/province-list');
  },

  /**
   * 查询开户行信息
   * @param pageSize 页大小（1-500）
   * @param pageNum 页数（从1开始）
   * @param keyword 查询关键字
   * @returns {*}
   */
  getBankList({ pageSize, pageNum, keyword = '' }) {
    return axios.get('/apigw/api/common/bank-by-page', {
      params: {
        pageSize,
        pageNum,
        keyword,
      },
    });
  },

  /**
   * 查询支行信息
   * @param bankId 总行编号
   * @param provinceId 省份编号
   * @returns {*}
   */
  getBranchBankList({ bankId, provinceId }) {
    return axios.get('/apigw/api/common/branch-list', {
      params: {
        bankId,
        provinceId,
      },
    });
  },

  /**
   * 钱袋宝协议预览
   * @param bankId 总行编号
   * @param provinceId 省份编号
   * @returns {*}
   */
  getQdbContractPreview({ partnerId }) {
    return axios.get('/apigw/api/kdb/qdb-contract-preview', {
      params: {
        partnerId,
      },
    });
  },

  /**
   * 保存银行卡（开通钱包）
   * @param {*} 开通参数
   * @returns {*}
   */
  createWallet(params) {
    return axios.post('/apigw/api/kdb/save-bankcard', params);
  },

  /**
   * 拒绝开通钱包
   * @param bankAccountId 银行卡ID
   * @param partnerId 客户ID
   * @returns {*}
   */
  refuseCreateWallet(params) {
    return axios.post('/apigw/api/kdb/refuse-bankcard', params);
  },

  uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/mapi/platform-stateless/kdb-uploadPic', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  getBankWhiteList() {
    return axios.get('/apigw/api/common/get-bank-whitelist');
  },
};
